import { useWindowDimensions } from 'react-native';

import { useResponsive } from '../../../hooks';
import { theme } from '@garnish/constants';
import { useContainerMaxWidth, useContainerSpacing } from '../../Container';

// ────────────────────────────────────────────────────────────────────────────────

export const useLoyaltyChallengeCardsRailDynamicProps = () => {
  const railMaxWidth = useRailMaxWidth();
  const railItemWidth = useRailItemWidth(railMaxWidth);
  const railOuterOffset = useRailOuterOffset();

  return {
    railOuterOffset,
    railItemWidth,
    railItemGap: RAIL_ITEM_GAP,
  };
};

// ────────────────────────────────────────────────────────────────────────────────

const useRailMaxWidth = () => {
  const { maxWidth: containerMaxWidth } = useContainerMaxWidth('large');

  const containerSpacing = useContainerSpacing();
  const containerSpacingsSum = containerSpacing * 2; // from both sides

  return typeof containerMaxWidth === 'number' // `maxWidth` can be given in string format too
    ? containerMaxWidth - containerSpacingsSum
    : containerMaxWidth;
};

const useRailOuterOffset = () => {
  const { width: windowWidth } = useWindowDimensions();
  const { maxWidth: containerMaxWidth } = useContainerMaxWidth('large');
  const containerSpacing = useContainerSpacing();

  const outerOffsetForLargeScreens = 0;
  const outerOffsetForSmallerScreens = -containerSpacing;

  return windowWidth > containerMaxWidth
    ? outerOffsetForLargeScreens
    : outerOffsetForSmallerScreens;
};

const useRailItemWidth = (railMaxWidth: number | string) => {
  const { match } = useResponsive();

  const railItemsGapSumLG = RAIL_VISIBLE_ITEMS_NUMBER_LG * RAIL_ITEM_GAP;
  const railWidthLG =
    typeof railMaxWidth === 'number'
      ? Math.floor(
          (railMaxWidth - railItemsGapSumLG) / RAIL_VISIBLE_ITEMS_NUMBER_LG,
        ) - RAIL_ITEM_GAP
      : RAIL_ITEM_WIDTH_MD;

  return match([
    RAIL_ITEM_WIDTH_XS,
    RAIL_ITEM_WIDTH_SM,
    RAIL_ITEM_WIDTH_MD,
    railWidthLG,
  ]);
};

// ────────────────────────────────────────────────────────────────────────────────

const RAIL_ITEM_WIDTH_XS = 310;
const RAIL_ITEM_WIDTH_SM = 330;
const RAIL_ITEM_WIDTH_MD = 360;

const RAIL_VISIBLE_ITEMS_NUMBER_LG = 4;

const RAIL_ITEM_GAP = theme.spacing.large;
